import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

import Base from './Base';

const useStyles = makeStyles(() => ({
  bold: {
    fontWeight: 800,
  },
}))

function FaceoffGameEvent({event, teams, players, periods}) {
  const classes = useStyles();
  const period = periods[event.period].name;
  const winner = players[event.winner];
  const loser = players[event.loser];
  const team = teams[winner.team].id

  return (
    <Base
      time={event.second}
      period={period}
      team={team}
      type="Faceoff"
    >
      <Typography variant="body2">
        <span className={classes.bold}>{winner.name}</span>
        {' '}wins face-off versus{' '}
        <span className={classes.bold}>{loser.name}</span>
        {' '}in the{' '}
        <span className={classes.bold}>{event.location}</span> 
      </Typography>
    </Base>
  )
}

export default FaceoffGameEvent;
